module.exports = __webpack_public_path__ + "img/pickup.87d04a61.svg";